// src/config/auth.ts
import { loadEnvConfig } from './env';

const origin = window.location.hostname === '127.0.0.1' 
  ? window.location.origin.replace('127.0.0.1', 'localhost')
  : window.location.origin;

type AuthConfig = {
  userPoolId: string;
  userPoolClientId: string;
  loginWith: {
    oauth: {
      domain: string;
      scopes: string[];
      redirectSignIn: string[];
      redirectSignOut: string[];
      responseType: 'code' | 'token';
    }
  }
};

export async function getAuthConfig(): Promise<AuthConfig> {
  const envConfig = await loadEnvConfig();

  // Remove any potential protocol from the domain
  const cognitoDomain = envConfig.REACT_APP_COGNITO_DOMAIN.replace(/^https?:\/\//, '');

  return {
    userPoolId: envConfig.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolClientId: envConfig.REACT_APP_COGNITO_CLIENT_ID,
    loginWith: {
      oauth: {
        domain: cognitoDomain,
        scopes: [
          'email',
          'openid',
          'profile',
          `${envConfig.REACT_APP_COGNITO_RESOURCE_SERVER_IDENTIFIER}/templates.analyze`,
          `${envConfig.REACT_APP_COGNITO_RESOURCE_SERVER_IDENTIFIER}/templates.generate`,
          `${envConfig.REACT_APP_COGNITO_RESOURCE_SERVER_IDENTIFIER}/templates.rewrite`,
          `${envConfig.REACT_APP_COGNITO_RESOURCE_SERVER_IDENTIFIER}/biases.read`,
          `${envConfig.REACT_APP_COGNITO_RESOURCE_SERVER_IDENTIFIER}/tasks.read`,
          `${envConfig.REACT_APP_COGNITO_RESOURCE_SERVER_IDENTIFIER}/models.read`
        ],
        redirectSignIn: [`${origin}/auth/callback`],
        redirectSignOut: [origin],
        responseType: 'code'
      }
    }
  };
}